import { useEffect } from "react";

const SITE = "https://skyglobal.co.id";
const OG_IMAGE = `${SITE}/skyglobal-removebg-preview.svg`;

function setMeta(attr, key, content) {
  if (!content) return;
  let tag = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attr, key);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

export default function usePageMeta({ title, description, path }) {
  useEffect(() => {
    if (title) {
      document.title = title;
      setMeta("property", "og:title", title);
      setMeta("name", "twitter:title", title);
    }

    if (description) {
      setMeta("name", "description", description);
      setMeta("property", "og:description", description);
      setMeta("name", "twitter:description", description);
    }

    if (path !== undefined) {
      const url = SITE + path;
      let canonical = document.head.querySelector('link[rel="canonical"]');
      if (!canonical) {
        canonical = document.createElement("link");
        canonical.setAttribute("rel", "canonical");
        document.head.appendChild(canonical);
      }
      canonical.setAttribute("href", url);
      setMeta("property", "og:url", url);
    }

    setMeta("property", "og:type", "website");
    setMeta("property", "og:site_name", "Sky Global");
    setMeta("property", "og:locale", document.documentElement.lang === "id" ? "id_ID" : "en_US");
    setMeta("property", "og:image", OG_IMAGE);
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:image", OG_IMAGE);
  }, [title, description, path]);
}
